import { render, staticRenderFns } from "./PaginationComponent.vue?vue&type=template&id=b4889ce0&scoped=true&"
import script from "./PaginationComponent.vue?vue&type=script&lang=js&"
export * from "./PaginationComponent.vue?vue&type=script&lang=js&"
import style0 from "./PaginationComponent.vue?vue&type=style&index=0&id=b4889ce0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4889ce0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
